import React from 'react';
import Box from '@sendsprint/ui-react/dist/components/Box';
import Button from '@sendsprint/ui-react/dist/components/Button';
import Text from '@sendsprint/ui-react/dist/components/Text';
import ClientApi from '@src/types/client';
import { convertToTime } from '@src/utils/convertToTime';
import useOtpScreen from '../../hooks/useOtpScreen';
import OtpField from '../otpField';

interface OtpScreenProps {
  changePhoneNumber?: () => void;
  counter: number;
  user?: ClientApi.General.UserProfile | null;
  verifyStatus?: boolean | null;
  handleStartTimer?: () => void;
  isStarted?: boolean;
  queryValues?: {
    email: string | null;
    hash: string | null;
  };
}

const OtpScreen: React.FC<OtpScreenProps> = ({
  changePhoneNumber,
  counter,
  user,
  verifyStatus,
  handleStartTimer,
  isStarted,
  queryValues
}) => {
  const { handleChangePhone, phoneValue, resendFunc, resendLoading } = useOtpScreen({
    changePhoneNumber,
    handleStartTimer,
    queryValues,
    user
  });

  return (
    <>
      <Text className="ss-text-neutral-40 ss-text-center">
        Please enter the code we sent to ( .. ) ...... {phoneValue.slice(-3)}.
      </Text>

      <Box className="ss-text-center">
        {!isStarted && counter && (
          <Button
            type="button"
            variant="tertiary"
            isBlock
            onClick={handleChangePhone}
            label="Change your phone number"
          />
        )}
      </Box>
      <OtpField verifyStatus={verifyStatus} name="otp" />
      <Box className="ss-text-center">
        {isStarted && counter ? (
          <Text className="ss-text-neutral-60 ss-font-bold ss-my-2">
            Resend code in {convertToTime(counter)}
          </Text>
        ) : (
          ''
        )}
        {!isStarted && counter && (
          <Box className="ss-flex ss-items-center ss-justify-center ss-gap-2">
            <p className="ss-text-neutral-400">Didn&apos;t get the code?</p>
            <button
              disabled={resendLoading}
              onClick={resendFunc}
              className="ss-outline-none focus:ss-focus-ring ss-text-primary1-500 ss-font-bold">
              {resendLoading ? 'Loading...' : 'Resend it'}
            </button>
          </Box>
        )}
      </Box>
    </>
  );
};

export default OtpScreen;
